// Initialize Mixpanel for product analytics
import { initMixpanel } from './mixpanel';
initMixpanel();

// Capture marketing attribution (UTMs + interest) on first page load.
// Must run AFTER initMixpanel so super-properties register on the live instance,
// and BEFORE React mounts so any wizard step that reads sessionStorage finds it.
import { captureMarketingParams } from './marketingAttribution';
captureMarketingParams();

// Initialize Google Analytics
import { initGtag } from './gtag';
initGtag();

// Initialize error log collector for support tickets
import { initErrorLogCollector } from './lib/error-log-collector';
initErrorLogCollector();

import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { EnvIndicatorBar } from '@elli/ui';
import './styles/tailwind.css';
import './styles/survey-theme.css';

// Initialize i18n before rendering
import './i18n/config';

const root = document.getElementById('root');

if (!root) {
  throw new Error('Root element not found');
}

/**
 * Loading fallback component displayed while translations are loading.
 * Shows a simple centered loading indicator.
 */
const LoadingFallback: React.FC = () => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      width: '100vw',
      fontSize: '1.25rem',
      color: '#510CFF',
    }}
  >
    Loading...
  </div>
);

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <Suspense fallback={<LoadingFallback />}>
      <BrowserRouter>
        <EnvIndicatorBar />
        <App />
      </BrowserRouter>
    </Suspense>
  </React.StrictMode>,
);
